import { render, staticRenderFns } from "./VerticalNavMenuHeader.vue?vue&type=template&id=44aa12ec&scoped=true"
import script from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuHeader.vue?vue&type=style&index=0&id=44aa12ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa12ec",
  null
  
)

export default component.exports